// Advertisement page — STORE_ADMIN placeholder for the "Coupons & Marketing"
// slot that has been promoted to a platform-only feature. Shows a friendly
// Coming Soon state so store admins know the capability is on the roadmap
// without exposing platform-level marketing controls.
import { Megaphone, Sparkles, Bell } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import PageHeader from "@/components/PageHeader";

export default function Advertisement() {
  return (
    <div className="p-4 md:p-8 max-w-[900px] mx-auto" data-testid="advertisement-page">
      <PageHeader
        title="Advertisement"
        subtitle="Boost your store's visibility with targeted ads."
      />
      <Card className="border-dashed border-2 border-amber-200 bg-amber-50/30">
        <CardContent className="p-10 md:p-14 text-center">
          <div className="inline-flex items-center gap-2 text-[10.5px] font-bold uppercase tracking-[0.16em] bg-amber-100 text-amber-700 rounded-full px-3 py-1 mb-6">
            <Sparkles className="w-3.5 h-3.5" /> Coming Soon
          </div>
          <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-amber-400 to-orange-500 text-white grid place-items-center shadow-lg">
            <Megaphone className="w-10 h-10" />
          </div>
          <h1 className="font-display text-2xl md:text-3xl font-bold mb-3">
            Advertisement Suite is on its way
          </h1>
          <p className="text-sm md:text-base text-muted-foreground max-w-md mx-auto mb-6">
            Soon you'll be able to run in-app ads, feature your store on top of
            search results, and promote products with a few clicks — right from
            here.
          </p>
          <div className="inline-flex items-center gap-2 text-xs text-muted-foreground bg-card border rounded-full px-4 py-2">
            <Bell className="w-3.5 h-3.5" />
            We'll notify you the moment it goes live.
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
